/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { allModules, allowedLogoFiles, emailPattern, noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { noop } from 'jquery';
import { NavbarComponent } from '../../../navbar/navbar.component';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-user-form',
	templateUrl: './user-form.component.html',
	styleUrl: './user-form.component.scss'
})
export class UserFormComponent implements OnChanges {
	moduleForm: FormGroup = this.formBuilder.group({
		email: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)]],
		first_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		last_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		email_signature: [null],
		sign: [null],
		line_items: this.formBuilder.array([])
	});
	showLoader = false;
	pageLoading1 = false;
	pageLoading2 = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	userDetails: any = null;
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }]
			]
		}
	};
	allowedLogoFiles = allowedLogoFiles;
	File_Storage_URL = environment.File_Storage_URL;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['uId']) {
			this.getUser();
		}
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['line_items'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			name: [null, [Validators.required]],
			key: [null, [Validators.required]],
			access: [null, [Validators.required]]
		});
		this.get_rows.push(form);
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getUser() {
		this.pageLoading1 = true;
		this.apiService.getUserDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.userDetails = data.data;
				this.f.email.setValue(this.userDetails.user.email);
				this.f.email_signature.setValue(this.userDetails.email_signature);
				this.f.sign.setValue(this.userDetails.sign);
				this.f.first_name.setValue(this.userDetails.user.first_name);
				this.f.last_name.setValue(this.userDetails.user.last_name);
				let len = allModules.length;
				for (let i = 0; i < len; i++) {
					this.addRow();
					this.get_rows.controls[i].get("name")?.setValue(allModules[i].name);
					this.get_rows.controls[i].get("key")?.setValue(allModules[i].key);
					this.get_rows.controls[i].get("access")?.setValue(null);
				}
				if (this.userDetails.access) {
					for (let i = 0; i < len; i++) {
						try {
							this.get_rows.controls[i].get("access")?.setValue(
								this.userDetails.access[this.get_rows.controls[i].get("key")?.value]
							);
						} catch (error) {
							this.get_rows.controls[i].get("access")?.setValue("NoAccess");
						}
					}
				}
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			email: this.f.email.value,
			username: this.f.email.value,
			first_name: this.f.first_name.value,
			last_name: this.f.last_name.value,
			email_signature: this.f.email_signature.value,
			sign: this.f.sign.value,
			type: "SC",
		};
		let access: any = {};
		for (let i = 0; i < this.get_rows.controls.length; i++) {
			if (this.get_rows.controls[i].get("key")?.value) {
				access[this.get_rows.controls[i].get("key")?.value] = this.get_rows.controls[i].get("access")?.value;
			}
		}
		data.access = access;
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateUser(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Updated successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							const val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								const selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) {
									noop;
								}
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					} else {
						errorMsg = "User already exists";
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	stampUploaded(filepath: any) {
		this.f.sign.setValue(filepath);
	}
}
